<template>
    <section
        class="o-flexible-module"
        :class="[{ 'o-flexible-module--flush': componentData.settings.spacing == 'flush' }]">
        <div v-if="componentData.settings.show_component_title" class="grid-container">
            <div class="grid-x grid-margin-x">
                <div class="small-12 cell">
                    <div class="utl-heading-beta">Content Cards</div>
                </div>
            </div>
        </div>

        <div
            class="c-content-cards js-content-cards"
            :class="[
                `t-${componentData.settings.theme}`,
                {
                    'has-fit-images': componentData.settings.fit_image_to_card,
                },
            ]"
            :data-component-id="componentId">
            <div class="c-content-cards__header">
                <div v-if="componentData.title || componentData.content" class="grid-container">
                    <div class="grid-x grid-margin-x">
                        <div class="small-12 cell" :class="[{ 'medium-5': componentData.content }]">
                            <template v-if="componentData.title">
                                <h2
                                    v-if="componentData.settings.heading_level == 'h2'"
                                    class="c-content-cards__title wow animate__animated animate__fadeIn"
                                    v-html="componentData.title"></h2>

                                <h3
                                    v-else-if="componentData.settings.heading_level == 'h3'"
                                    class="c-content-cards__title wow animate__animated animate__fadeIn"
                                    v-html="componentData.title"></h3>

                                <div
                                    v-else
                                    class="c-content-cards__title wow animate__animated animate__fadeIn"
                                    v-html="componentData.title"></div>
                            </template>
                        </div>

                        <div v-if="componentData.content" class="small-12 medium-6 medium-offset-1 cell">
                            <div
                                class="c-content-cards__content wow animate__animated animate__fadeIn"
                                v-html="componentData.content"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="grid-container">
                <div class="grid-x grid-margin-x">
                    <div class="small-12 cell">
                        <div :class="`c-content-cards__items has-${componentData.items.length}-items s-swiper`">
                            <swiper-container
                                ref="containerRef"
                                :init="false"
                                :navigation-next-el="`.js-content-cards[data-component-id=${componentId}] .js-swiper-button-next`"
                                :navigation-prev-el="`.js-content-cards[data-component-id=${componentId}] .js-swiper-button-prev`"
                                :pagination-el="`.js-content-cards[data-component-id=${componentId}] .js-swiper-pagination`">
                                <swiper-slide v-for="(card, index) in componentData.items" :key="index">
                                    <div :class="`c-content-cards__item has-${card.media_type}`">
                                        <div
                                            v-if="card.media_type == 'image' && card.image"
                                            class="c-content-cards__item-media is-image wow animate__animated animate__fadeInUp"
                                            v-html="card.image.attachments['large']"></div>

                                        <div
                                            v-else-if="card.media_type == 'icon' && card.icon.element"
                                            class="c-content-cards__item-media is-icon wow animate__animated animate__fadeInUp"
                                            v-html="card.icon.element"></div>

                                        <template v-if="card.title">
                                            <h2
                                                v-if="card.settings.heading_level == 'h2'"
                                                class="c-content-cards__item-title wow animate__animated animate__fadeIn"
                                                v-html="card.title"></h2>

                                            <h3
                                                v-else-if="card.settings.heading_level == 'h3'"
                                                class="c-content-cards__item-title wow animate__animated animate__fadeIn"
                                                v-html="card.title"></h3>

                                            <div
                                                v-else
                                                class="c-content-cards__item-title wow animate__animated animate__fadeIn"
                                                v-html="card.title"></div>
                                        </template>

                                        <div
                                            v-if="card.content"
                                            class="c-content-cards__item-content s-wp-cms wow animate__animated animate__fadeIn"
                                            v-html="card.content"></div>

                                        <NuxtLink
                                            v-if="card.link"
                                            noPrefetch
                                            :to="card.link.url"
                                            :target="card.link.target"
                                            class="c-content-cards__item-link wow animate__animated animate__fadeIn">
                                            <span v-html="card.link.title"></span>
                                        </NuxtLink>
                                    </div>
                                </swiper-slide>
                            </swiper-container>

                            <div
                                v-if="componentData.items.length > 1"
                                class="swiper-pagination js-swiper-pagination"></div>

                            <div v-if="componentData.items.length > 2" class="swiper-navigation">
                                <button
                                    class="swiper-button-prev js-swiper-button-prev"
                                    aria-label="Previous slide"
                                    type="button">
                                    <i class="fa-sharp fa-chevron-left"></i>
                                </button>

                                <button
                                    class="swiper-button-next js-swiper-button-next"
                                    aria-label="Next slide"
                                    type="button">
                                    <i class="fa-sharp fa-chevron-right"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup>
    const props = defineProps({
        componentData: {
            type: Object,
            required: true,
        },
    });

    const componentId = useId();
    const containerRef = ref(null);
    const swiper = useSwiper(containerRef, {
        autoHeight: true,
        breakpoints: {
            768: {
                pagination: {
                    enabled: false,
                },
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1024: {
                pagination: {
                    enabled: false,
                },
                slidesPerView: 3,
                spaceBetween: 20,
            },
        },
        navigation: {
            enabled: true,
        },
        pagination: {
            clickable: true,
            enabled: true,
        },
        slidesPerView: 1,
        spaceBetween: 0,
    });

    // console.log("Data: ", props.componentData);
</script>
